const createMemoryStorage = () => {
  let store = {}
  return {
    getItem(key) {
      return store.hasOwnProperty(key) ? store[key] : null
    },
    setItem(key, value) {
      store[key] = String(value)
    },
    removeItem(key) {
      delete store[key]
    },
    clear() {
      store = {}
    },
  }
}

const createSafeStorage = () => {
  try {
    const testKey = '__storage_test__'
    window.localStorage.setItem(testKey, '1')
    window.localStorage.removeItem(testKey)

    return {
      getItem: (key) => {
        return window.localStorage.getItem(key)
      },
      setItem: (key, value) => {
        try {
          window.localStorage.setItem(key, value)
        } catch (e) {
          if (
            e.name === 'QuotaExceededError' ||
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
          ) {
            console.warn(
              'localStorage quota exceeded, falling back to memory storage.'
            )
            safeStorage = createMemoryStorage()
            safeStorage.setItem(key, value)
          } else {
            throw e
          }
        }
      },
      removeItem: (key) => window.localStorage.removeItem(key),
      clear: () => window.localStorage.clear(),
    }
  } catch (e) {
    console.warn('localStorage not available, using memory storage.')
    return createMemoryStorage()
  }
}

let safeStorage = createSafeStorage()
export default safeStorage
